import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Endpoints, QuestActions, LevelUpResponseKeys } from './Constants';
import RequestHelper from './RequestHelper';
import store from '../state/store';
import transformObjectResponseKeys from '../utils/transformObjectResponseKeys';
import { setXpRequired } from '../state/slices/xp/xp';
import { fetchGameRooms } from '../state/query/games/utils';
import PlayerInterface from './PlayerInterface';
import utils from '../utils';
import Logger from '../lib/analytics/logger';
import { EVENT_TYPES } from '../lib/analytics/constants';

var EventEmitter = require('events');

var LevelUpInterface = /*#__PURE__*/function (_EventEmitter) {
  _inherits(LevelUpInterface, _EventEmitter);

  var _super = _createSuper(LevelUpInterface);

  function LevelUpInterface() {
    _classCallCheck(this, LevelUpInterface);

    return _super.apply(this, arguments);
  }

  _createClass(LevelUpInterface, [{
    key: "tryLevelUp",
    value:
    /**
     * Update all level up info in the global state.
     * @return {Promise<boolean>} Was info loaded into state successfully?
     */
    function () {
      var _tryLevelUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var callResponse, response, coin, xp, eventPayload, state, currentXp, XpLevelNeededToReachNextLevel;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(utils.getPlatform() === 'web')) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1200);
                });

              case 3:
                _context.next = 5;
                return RequestHelper.apiGet({
                  endpoint: Endpoints.LEVEL_UP,
                  logPromise: true,
                  logJSON: true
                }, true);

              case 5:
                callResponse = _context.sent;
                // Do transformations

                /** @type {LevelUpResponseKeys} */
                response = callResponse;
                response = !!callResponse && transformObjectResponseKeys(response, LevelUpResponseKeys);

                if (callResponse) {
                  coin = parseInt(store.getState().coin.value);
                  xp = RequestHelper.getPreviousXp();
                  fetchGameRooms(true);
                  eventPayload = {
                    level_after: response.REWARD.currentLevel,
                    xp_before: xp.toString(),
                    coins: response.REWARD.c,
                    balance_before: (coin - parseInt(response.REWARD.c)).toString()
                  };

                  if (response.CAMPAIGN_INFO && response.CAMPAIGN_INFO.appsflyer === 'yes') {
                    Logger.sendEvent(EVENT_TYPES.LEVEL_UP, eventPayload);
                  }
                }

                console.log('[LevelUpInterface::tryLevelUp]');

                if (!(callResponse === false)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", false);

              case 12:
                _context.next = 14;
                return PlayerInterface.getPlayerExtras();

              case 14:
                state = store.getState();
                currentXp = state.xpInfo.xp;
                XpLevelNeededToReachNextLevel = response.XP_TO_NEXT + currentXp;
                store.dispatch(setXpRequired(XpLevelNeededToReachNextLevel));
                this.emit('LEVEL_UP', response);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function tryLevelUp() {
        return _tryLevelUp.apply(this, arguments);
      }

      return tryLevelUp;
    }()
  }]);

  return LevelUpInterface;
}(EventEmitter);

export default new LevelUpInterface();